var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "searchchooser" },
    [
      _vm.showDropdown
        ? _c("b-autocomplete", {
            ref: `autocomplete_${_vm._uid}`,
            staticClass: "search",
            class: { "has-error": _vm.v && _vm.v.$anyError },
            attrs: {
              data: _vm.results,
              placeholder: _vm.placeholder ? _vm.placeholder : _vm.$t("search"),
              field: "title",
              loading: _vm.isSearching,
              "icon-pack": "fas",
              icon: "search",
              clearable: "",
              "open-on-focus": true,
              "keep-first": true,
            },
            on: {
              typing: _vm.doAutoComplete,
              select: _vm.onClick,
              input: _vm.onInput,
              focus: _vm.onFocus,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (props) {
                    return [_vm._t("results", null, null, props.option)]
                  },
                },
                {
                  key: "header",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        { staticClass: "head" },
                        [
                          _vm.isSearching
                            ? [
                                _c("loader", {
                                  attrs: { text: _vm.$t("searching") },
                                }),
                              ]
                            : [
                                _c(
                                  "div",
                                  [
                                    _vm.useSearch
                                      ? [
                                          _c("strong", [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  _vm.labelResults
                                                    ? _vm.labelResults
                                                    : _vm.$t("searchResults")
                                                ) +
                                                "\n                            "
                                            ),
                                          ]),
                                        ]
                                      : _vm.useSearch && _vm.results.length == 0
                                      ? [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(_vm.$t("noresults")) +
                                              "\n                        "
                                          ),
                                        ]
                                      : _vm.useRecent
                                      ? [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(
                                                _vm.labelRecent
                                                  ? _vm.labelRecent
                                                  : _vm.$t("recentlyUsed")
                                              ) +
                                              "\n                        "
                                          ),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _vm.showAdd
                                  ? [
                                      _c("div", { staticClass: "ml-auto" }),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "button is-success is-small",
                                          attrs: {
                                            href: "javascript:void(0);",
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                              return _vm.doAdd.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(_vm.$t("createNew")) +
                                              "\n                        "
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                        ],
                        2
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "empty",
                  fn: function () {
                    return [
                      !_vm.isSearching
                        ? [_vm._v(_vm._s(_vm.$t("noresults")))]
                        : _vm._e(),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "footer",
                  fn: function () {
                    return [
                      _vm.moreResults > 0 && !_vm.isSearching
                        ? [
                            _c("strong", [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$t("moreResults", {
                                      count: _vm.moreResults,
                                    })
                                  ) +
                                  "\n                "
                              ),
                            ]),
                          ]
                        : _vm._e(),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              true
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.value && !_vm.showNoValueDisabled && _vm.showSelectedFiles
        ? [
            _vm.isMultiple && _vm.value.length > 0
              ? _c(
                  "div",
                  { staticClass: "items" },
                  [
                    _c(
                      "v-popover",
                      {
                        class: {
                          pointer: _vm.usePopover,
                        },
                        attrs: { offset: "15", disabled: !_vm.usePopover },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "popover",
                              fn: function () {
                                return _vm._l(
                                  _vm.value,
                                  function (item, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass: "card card-contact",
                                      },
                                      [
                                        _vm._t(
                                          "selectedItems",
                                          null,
                                          null,
                                          item
                                        ),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "ml-auto" }),
                                        _vm._v(" "),
                                        !_vm.hideDetail
                                          ? _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "button is-detailMenu on-hover",
                                                on: {
                                                  click: function ($event) {
                                                    $event.preventDefault()
                                                    return _vm.showDetailClick(
                                                      _vm.value
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  attrs: {
                                                    icon: ["fas", "eye"],
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !_vm.iniDisabled
                                          ? _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "button is-danger is-small on-hover",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.removeFromSelected(
                                                      index
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  attrs: {
                                                    icon: ["fas", "trash-alt"],
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      2
                                    )
                                  }
                                )
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      _vm._l(
                        _vm.value.slice(0, _vm.slicerCount),
                        function (item, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass: "card card-contact",
                              class: { "has-popover": _vm.usePopover },
                            },
                            [
                              _vm._t("selectedItems", null, null, item),
                              _vm._v(" "),
                              _c("div", { staticClass: "ml-auto" }),
                              _vm._v(" "),
                              !_vm.usePopover && !_vm.hideDetail
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "button is-detailMenu on-hover",
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.showDetailClick(item)
                                        },
                                      },
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        attrs: { icon: ["fas", "eye"] },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.usePopover
                                ? _c(
                                    "b-tag",
                                    { attrs: { type: "is-success" } },
                                    [
                                      _vm._v(
                                        "+ " + _vm._s(_vm.value.length - 1)
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.iniDisabled
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "button is-danger is-small on-hover",
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeFromSelected(index)
                                        },
                                      },
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        attrs: { icon: ["fas", "trash-alt"] },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            2
                          )
                        }
                      ),
                      0
                    ),
                  ],
                  1
                )
              : _vm.value
              ? _c("div", { staticClass: "items" }, [
                  _c(
                    "div",
                    { staticClass: "card card-contact" },
                    [
                      _vm._t("selectedItems", null, null, _vm.value),
                      _vm._v(" "),
                      _c("div", { staticClass: "ml-auto" }),
                      _vm._v(" "),
                      !_vm.hideDetail
                        ? _c(
                            "button",
                            {
                              staticClass: "button is-detailMenu on-hover",
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.showDetailClick(_vm.value)
                                },
                              },
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: ["fas", "eye"] },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.iniDisabled
                        ? _c(
                            "button",
                            {
                              staticClass: "button is-danger is-small on-hover",
                              on: {
                                click: function ($event) {
                                  return _vm.resetValue()
                                },
                              },
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: ["fas", "trash-alt"] },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ])
              : _vm._e(),
          ]
        : _vm.showNoValueDisabled
        ? [_c("textInput", { attrs: { iniDisabled: true } })]
        : _vm._e(),
      _vm._v(" "),
      _vm.v && _vm.v.$anyError
        ? _c("span", { staticClass: "help is-danger" }, [_vm._t("onError")], 2)
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }